var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.051,
    viewBox: "0 0 20 19.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4.869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7,12.056a3.494,3.494,0,0,1-3.072-5.093,9.974,9.974,0,0,0-3.715-2.094,3.5,3.5,0,0,1-5.832,0A9.974,9.974,0,0,0,7.37,6.963,3.494,3.494,0,0,1,4.3,12.056a9.711,9.711,0,0,0-.115,4.254,3.5,3.5,0,0,1,3,5.422,9.979,9.979,0,0,0,3.67,2.188,3.494,3.494,0,0,1,6.3,0,9.979,9.979,0,0,0,3.67-2.187,3.5,3.5,0,0,1,3-5.421,9.722,9.722,0,0,0-.114-4.255Z",
    fill: "#3bafca"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.393 9.984)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.477,18.211v1.055l-2.951,1.263v.027l2.951,1.187V22.8L9.338,20.91v-.718l4.139-1.981m.494-.784-.707.338L9.125,19.746l-.281.134v1.347l.289.132,4.139,1.888.7.319V21.409l-.31-.124-1.88-.756,1.889-.809.3-.128V17.427Z",
    transform: "translate(-8.844 -16.228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.067,15.494l-3.1,7.41h-1.25l3.084-7.41h1.263M23.809,15H21.474l-.126.3-3.084,7.41-.285.684H20.3l.127-.3,3.1-7.41L23.809,15Z",
    transform: "translate(-13.348 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.271,18.124l4.139,1.967v.718L29.271,22.7v-1.05l2.96-1.183v-.018l-2.96-1.268V18.124m-.494-.782V19.5l.3.128,1.884.807-1.873.749-.311.124v2.153l.7-.319,4.139-1.888.289-.132V19.779l-.282-.134-4.139-1.967-.706-.336Z",
    transform: "translate(-18.689 -16.185)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.64 10.231)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.73,18.613v1.055L10.778,20.93v.027l2.951,1.187V23.2L9.591,21.312v-.718l4.139-1.981m.247-.392-.354.169L9.484,20.371l-.14.067v1.032l.145.066,4.139,1.888.349.16V21.978l-.155-.062-2.431-.979,2.436-1.043.15-.064V18.221Z",
    transform: "translate(-9.344 -16.877)",
    fill: "#3bafca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.446,15.747l-3.1,7.41H19.1l3.084-7.41h1.263m.371-.247h-1.8l-.063.152-3.084,7.41-.142.342h1.785l.063-.152,3.1-7.41.143-.342Z",
    transform: "translate(-13.974 -15.5)",
    fill: "#3bafca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.524,18.524l4.139,1.967v.718L29.524,23.1v-1.05l2.96-1.183v-.018l-2.96-1.268V18.524m-.247-.391v1.608l.15.064,2.433,1.042-2.427.97-.155.062v1.6l.349-.16,4.139-1.888.145-.066V20.336l-.141-.067L29.631,18.3l-.354-.168Z",
    transform: "translate(-19.189 -16.832)",
    fill: "#3bafca"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.983,23.6,9.844,21.714V21l4.139-1.981V20.07l-2.951,1.263v.027l2.951,1.187Z",
    transform: "translate(-2.957 -7.046)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.825,16l-3.1,7.41h-1.25L22.562,16Z",
    transform: "translate(-7.713 -5.522)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.916,21.61,29.777,23.5v-1.05l2.96-1.183v-.018l-2.96-1.268V18.925l4.139,1.967Z",
    transform: "translate(-12.803 -7.001)",
    fill: "aqua"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/backend.ab88454eddeb6c2089ba351d919e2af9.svg";
export { ForwardRef as ReactComponent };